import CampaignBanners from './CampaignBanners';

export default CampaignBanners;
